import { TDeclineReasonsData } from 'lendingApi/lendingApi.types';

export const DeclinedSubheading = ({
  reasons,
  fallback,
}: {
  reasons?: TDeclineReasonsData;
  fallback: string;
}) => {
  if (!reasons || reasons.length === 0) return <>{fallback}</>;

  const label = reasons.length > 1 ? 'Reasons' : 'Reason';

  return (
    <>
      <p>We are unable to proceed with your application at this time.</p>
      <span>{label} for decline:</span>
      <ul>
        {reasons.map((declineReason) => (
          <li key={declineReason.reason}>{declineReason.reason}</li>
        ))}
      </ul>
    </>
  );
};
